import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";

/**
 * Props:
 *  - catName: optional string (category/title)
 *  - quesLength: number of questions / duration
 *  - onBegin: function to call when user clicks the begin button
 * 
 * 
 */



const TestInstructions = ({ catName = "", quesLength = 30, onBegin }) => {
  const marks = quesLength;
  const duration = quesLength;

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
  }, []);

  return (
    <div className="ti-root">
      <div className="ti-card">
        <div className="ti-card-inner">
          <div className="ti-header-row">
            <div className="ti-marks">Maximum Marks: <strong>{marks}</strong></div>
            <div className="ti-title">{catName.toUpperCase() ? `${catName.toUpperCase()} — Instructions` : "Test Instructions"}</div>
            <div className="ti-duration">Duration: <strong>{duration} mins</strong></div>
          </div>

          <div className="ti-instructions">
            <InstructionLine>
              The test consists of <strong>{quesLength}</strong> questions. Each correct answer is
              awarded one mark.
            </InstructionLine>

            <InstructionLine>
              There is no negative marking. Attempt every question you can within the allotted time.
            </InstructionLine>

            <InstructionLine>
              Total time allowed for this test is <strong>{duration} minutes</strong>. The timer starts
              when you enter the test console.
            </InstructionLine>

            <InstructionLine>
              Your answers are saved automatically as you navigate. Make sure to review marked
              questions before submission.
            </InstructionLine>

            <InstructionLine>
              Results, rank and Answer key with explanations will be shown after you complete the test.
            </InstructionLine>

            <div className="ti-warning" role="alert" aria-live="polite">
              <svg className="ti-warning-icon" viewBox="0 0 24 24" aria-hidden>
                <path fill="currentColor" d="M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"/>
              </svg>
              <div className="ti-warning-text">
                Important: Once the test begins you cannot pause the test or refresh the page. Avoid closing
                the browser until you submit the test. Loss of connectivity may terminate the session;
                please ensure a stable connection before starting.
              </div>
            </div>
          </div>

          <div className="ti-footer">
            <button
              className="ti-begin-btn"
              onClick={() => typeof onBegin === "function" ? onBegin() : null}
              aria-label="Begin Test"
            >
              <span className="ti-begin-label">I'm Ready — Begin Test</span>
              <span className="ti-begin-icon" aria-hidden>
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path className="arrow-tail" d="M5 12h12" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                  <path className="arrow-head" d="M13 6l6 6-6 6" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </span>
            </button>
          </div>

        </div>
      </div>
    </div>
  );
};

function InstructionLine({ children }) {
  return (
    <div className="ti-line">
      <span className="ti-chevron" aria-hidden>›</span>
      <div className="ti-line-text">{children}</div>
    </div>
  );
}

TestInstructions.propTypes = {
  catName: PropTypes.string,
  quesLength: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  onBegin: PropTypes.func,
};

export default TestInstructions;
